module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('va-box', {
    attrs: {
      "theme": "box-primary",
      "title": "Expandable",
      "widgetType": ""
    }
  }, [_c('div', {
    staticClass: "table-responsive",
    slot: "content"
  }, [_c('p', [_vm._v("Various types of buttons. Using the base class "), _c('code', [_vm._v(".btn")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered text-center"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Normal")]), _vm._v(" "), _c('th', [_vm._v("Large "), _c('code', [_vm._v(".btn-lg")])]), _vm._v(" "), _c('th', [_vm._v("Small "), _c('code', [_vm._v(".btn-sm")])]), _vm._v(" "), _c('th', [_vm._v("X-Small "), _c('code', [_vm._v(".btn-xs")])]), _vm._v(" "), _c('th', [_vm._v("Flat "), _c('code', [_vm._v(".btn-flat")])]), _vm._v(" "), _c('th', [_vm._v("Disabled "), _c('code', [_vm._v(".disabled")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('va-button', {
    attrs: {
      "name": "Default",
      "theme": "default"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Default",
      "theme": "default",
      "size": "btn-lg"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Default",
      "theme": "default",
      "size": "btn-sm"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Default",
      "theme": "default",
      "size": "btn-xs"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Default",
      "theme": "default",
      "isFlat": true
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Default",
      "theme": "default",
      "isDisabled": true
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('va-button', {
    attrs: {
      "name": "Primary",
      "theme": "primary"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Primary",
      "theme": "primary",
      "size": "btn-lg"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Primary",
      "theme": "primary",
      "size": "btn-sm"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Primary",
      "theme": "primary",
      "size": "btn-xs"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Primary",
      "theme": "primary",
      "isFlat": true
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Primary",
      "theme": "primary",
      "isDisabled": true
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('va-button', {
    attrs: {
      "name": "Success",
      "theme": "success"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Success",
      "theme": "success",
      "size": "btn-lg"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Success",
      "theme": "success",
      "size": "btn-sm"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Success",
      "theme": "success",
      "size": "btn-xs"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Success",
      "theme": "success",
      "isFlat": true
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Success",
      "theme": "success",
      "isDisabled": true
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('va-button', {
    attrs: {
      "name": "Info",
      "theme": "info"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Info",
      "theme": "info",
      "size": "btn-lg"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Info",
      "theme": "info",
      "size": "btn-sm"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Info",
      "theme": "info",
      "size": "btn-xs"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Info",
      "theme": "info",
      "isFlat": true
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Info",
      "theme": "info",
      "isDisabled": true
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('va-button', {
    attrs: {
      "name": "Danger",
      "theme": "danger"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Danger",
      "theme": "danger",
      "size": "btn-lg"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Danger",
      "theme": "danger",
      "size": "btn-sm"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Danger",
      "theme": "danger",
      "size": "btn-xs"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Danger",
      "theme": "danger",
      "isFlat": true
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Danger",
      "theme": "danger",
      "isDisabled": true
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('va-button', {
    attrs: {
      "name": "Warning",
      "theme": "warning"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Warning",
      "theme": "warning",
      "size": "btn-lg"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Warning",
      "theme": "warning",
      "size": "btn-sm"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Warning",
      "theme": "warning",
      "size": "btn-xs"
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Warning",
      "theme": "warning",
      "isFlat": true
    }
  })], 1), _vm._v(" "), _c('td', [_c('va-button', {
    attrs: {
      "name": "Warning",
      "theme": "warning",
      "isDisabled": true
    }
  })], 1)])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Block Buttons",
      "widgetType": ""
    }
  }, [_c('div', {
    staticClass: "table-responsive",
    slot: "content"
  }, [_c('va-button', {
    attrs: {
      "name": ".btn-block"
    }
  }), _vm._v(" "), _c('va-button', {
    attrs: {
      "name": ".btn-block",
      "isFloat": true
    }
  }), _vm._v(" "), _c('va-button', {
    attrs: {
      "name": ".btn-block",
      "size": "btn-sm"
    }
  })], 1)]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Horizontal Button Group",
      "widgetType": ""
    }
  }), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Button Addon",
      "widgetType": ""
    }
  }), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Split buttons",
      "widgetType": ""
    }
  }), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Social Buttons (By Lipis)",
      "widgetType": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a559329!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ui-elements/Buttons.vue
// module id = 526
// module chunks = 1